import {AppState} from "../store";

export const getTicketsPageFilter = (state: AppState) => state.ticketsPage.filter
